import { getFeature } from "./util";
import useOrganisation from "../../hooks/useOrganisation";
import useUser from "../../hooks/useUser";
import useFeatureConfig from "./useFeatureConfig";
import useFetchAllPlans from "../../hooks/useFetchAllPlans";
import useModuleInfo from "../../hooks/useModuleInfo";
import { Modules } from "../../util/constants";

const SUBSCRIPTION_FEATURE_PENDING = {
  enabled: false,
  beta: false,
  promote: false,
  plans: [],
  canAccess: false,
  hasAddons: false,
  loading: true,
};

function useFeature(name, featureVariant, moduleName = Modules.RECEIVABLES) {
  const { plan, subscription, loading } = useModuleInfo(moduleName, {
    suspense: false,
  });
  const firebaseFeatures = useFeatureConfig();
  const { data: plans = {} } = useFetchAllPlans({
    moduleName,
    suspense: false,
  });

  const user = useUser();
  const org = useOrganisation(null, {
    suspense: false,
  });

  if (loading) return SUBSCRIPTION_FEATURE_PENDING;

  return getFeature(
    firebaseFeatures,
    name,
    user,
    org,
    plans,
    plan,
    featureVariant,
    subscription,
  );
}

export default useFeature;
